// @core/api/endpoints/resource/get_link_stats.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LinkStatsResponse,
} from '../../../types/resource';

const BASE_PATH = '/resource';

/**
 * Get link statistics for a resource
 * Returns aggregated statistics about a resource's links including counts of incoming and outgoing links, broken down by relation type and source/target type.
 */
export async function GetLinkStats(
  resource_type: string,
  resource_id: string,
  options?: RequestOptions
): Promise<LinkStatsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/resources/:resource_type/:resource_id/stats`;
  requestPath = requestPath.replace(':resource_type', encodeURIComponent(resource_type));
  requestPath = requestPath.replace(':resource_id', encodeURIComponent(resource_id));
  const requestOptions = options;
  return client.get<LinkStatsResponse>(requestPath, { ...requestOptions });
}
